module.exports = __webpack_public_path__ + "static/media/442449260_935212441735622_7034095753701171808_n-min (1).a2865650.jpg";